import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AwsPipe } from '../../pipes/aws/aws.pipe';
import { AudioService } from './audio.service';

/**
 * Audio Module.
 */
@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [AudioService, AwsPipe]
})
export class AudioModule {}
